import PadraoModel from 'src/core/model/PadraoModel.js'

export default class DominioNovosCredereModel extends PadraoModel {
  recurso = 'credere/dominios-novos';
  microServico = 'usuario';
  include = null;
  searchFixo = null;
  nome = 'Domínios Novos da Credere';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null,
    ativo: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
